import config from "config/config";
import { useState } from "react";
import { Button, ButtonVariant, Checkbox } from "shared/components";
import { Partner } from "types/landlord/partner";

type SignOnBehalfStepProps = {
  partnerNameInSubmissionDisclosure: string;
  partner?: Partner;
  onSignOnBehalf: () => void;
  isLoading: boolean;
  applicationId: number;
  applicantId: number;
};

export const SignOnBehalfStep = ({
  partnerNameInSubmissionDisclosure,
  onSignOnBehalf,
  isLoading,
  applicationId,
  applicantId
}: SignOnBehalfStepProps) => {
  const [hasCertified, setHasCertified] = useState(false);

  const submission_disclosure_link =
    !!applicationId && !!applicantId
      ? `${config.apiHost}/portal/v1/applications/${applicationId}/applicants/${applicantId}/submission_disclosure_pdf`
      : "#";

  return (
    <>
      <div className="max-w-[500px] w-full h-full mx-auto overflow-y-auto pt-10">
        <h1 className="font-bold text-xl border-b border-alpha-40 pb-4 mb-4">
          I hereby certify and attest that I, as the property manager or
          authorized agent for {partnerNameInSubmissionDisclosure}, have:
        </h1>
        <ol className="space-y-1 list-decimal list-outside pl-4 font-medium text-sm text-content-400">
          <li>
            Provided the rental applicant with the most recent version of
            BoomPay, Inc.’s{" "}
            <a
              target="_blank"
              href={submission_disclosure_link}
              className="text-primary-500 underline"
              rel="noreferrer"
            >
              submission disclosure
            </a>
            , including all federally and state-required disclosures under the
            Fair Credit Reporting Act (FCRA) and applicable state law;
          </li>
          <li>
            Obtained the applicant’s express written consent and authorization,
            evidenced by their signed acknowledgment of the submission
            disclosure, permitting BoomPay, Inc. to obtain consumer reports
            and/or investigative consumer reports on the applicant for housing
            purposes; and
          </li>
          <li>
            Retained a copy of the applicant’s signed Submission Disclosure in
            accordance with applicable law and will make it available to
            BoomPay, Inc. upon request
          </li>
        </ol>
        <div className="mt-8">
          <Checkbox
            key="agreed_to_sign_on_behalf"
            id="agreed_to_sign_on_behalf"
            checked={hasCertified}
            label="By checking this box, I certify that all statements are true and accurate, and that I have fulfilled the requirements described above."
            labelClassName="whitespace-normal"
            onChange={() => setHasCertified((prev) => !prev)}
          />
        </div>
      </div>
      <div className="h-20 border-t border-alpha-100 bg-white gap-2 flex justify-end items-center pr-4">
        <Button
          tooltipZIndex={51}
          variant={ButtonVariant.PRIMARY}
          className="w-[125px]"
          onClick={onSignOnBehalf}
          loading={isLoading}
          disabled={!hasCertified}
        >
          Confirm
        </Button>
      </div>
    </>
  );
};
